import React, { useEffect, useState } from "react"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { siteUrl } from "../../../shared/utils/siteUrl"
import { removeDoubleSlash } from "../../../shared/utils/urlUril"
import useMediaQuery from "../../../shared/utils/useMediaQuery"
import "./card-article-mg.scss"

const CardArticleMG = props => {
  const {
    localLikes,
    handleLike,
    handleUnLike,
    categoryFilterTitleActive /*, item, handleSave, savedArticles, handleUnSave */,
  } = props
  const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ]
  const getDate = date => {
    var dateForm = new Date(date)
    return dateForm.getDate() + " de " + monthNames[dateForm.getMonth()] //+ " de " + dateForm.getFullYear()
  }

  const homeLink = siteUrl + "/magazin/nuestro-mundo/"
  const isMobile = useMediaQuery()

  const iconType = () => {
    if (props.item?.etiquetas[0].slug) {
      switch (props.item?.etiquetas[0].slug) {
        case "articulos":
          return <span className="icon2-articulo"></span>
        case "videos":
          return <span className="icon-entertaiment"></span>
        case "paso-a-paso":
          return <span className="icon2-paso-paso"></span>
        case "test":
          return <span className="icon2-test"></span>

        default:
          break
      }
    }
  }


  // var payload = {
  //     id: item.id,
  //     titulo: item.metaTitulo,
  //     descripcion: item.metaDescripcion.metaDescripcion,
  //     imagen: item.metaImagen,
  //     categorias: item.categorias,
  //     slug: '/magazin/nuestro-mundo/' + item.slug,
  //     imagenCreadorArticulo: item.imagenCreadorArticulo,
  //     tipoDeArticulo: item.tipoDeArticulo,
  //     updatedAt: item.updatedAt,
  //     nombreCreadorArticulo: item.nombreCreadorArticulo,
  //     creadorArtculo: item.creadorArtculo
  // }

  const userInfoEncrypt= encryptUserInfo()
  const articleMagazinDatalayer = (article) => {
    pushDataLayerEvent({
      event: "Interacciones - Articulos",
      category: "magazin",
      sub_category: "Nuestro Mundo",
      action: "click",
      label: article.tituloArticulo,
      article_name: article.tituloArticulo,
      location: window.location.href,
      article_type: article.tipoDeArticulo,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
    pushDataLayerEvent({
      event: "article_click",
      link_text: article.tituloArticulo,
      link_url: window.location.href,
      article_name: article.tituloArticulo
    })
  }

  return (
    <>
      {props.item && (
        <a
          href={homeLink + removeDoubleSlash(props.item?.slug || "")}
          className={
            props.indexItem % 3 !== 0 ? "f-card" : "f-card f-card-thirditem"
          }
          onClick={(e) => {
            articleMagazinDatalayer(props.item)
          }}
        >
          <div className="f-card-typeIcon">{iconType()}</div>
          <img
            className="f-card-imgarticle"
            loading={ isMobile ? 'lazy' : (props.indexItem === 1 || props.indexItem === 2) ? 'eager' : 'lazy' }
            alt={props.item.imagenArticuloPrevisualizacion[0].description}
            src={props.item.imagenArticuloPrevisualizacion[0].file.url
            }
          />
          <div className="f-card-info ">
            <div className="f-card-info-interaction">
              {/* {savedArticles.filter(a => a.id === item.id).length !== 0 ?
                                <span className="icon2-guardado-active " onClick={e => handleUnSave(e, item.id)} />
                                :
                                <span className="icon-save " onClick={e => handleSave(e, payload)} />
                            } */}
              {localLikes.includes(props.item.contentful_id) ? (
                <span
                  className="icon2-corazon-relleno1 f-icon-heart"
                  onClick={e => {
                    handleUnLike(props.item.contentful_id)
                  }}
                />
              ) : (
                <span
                  className="icon-heart"
                  onClick={e => {
                    handleLike(props.item.contentful_id)
                  }}
                />
              )}
            </div>
            <div className="f-card-info-user">
              {props.item.imagenCreadorArticulo && (
                <img
                  className="f-card-info-user-img"
                  alt={props.item.imagenCreadorArticulo.description}
                  src={props.item.imagenCreadorArticulo.file.url}
                />
              )}
              <span className="f-card-info-user-name">
                {props.item.nombreCreadorArticulo}
              </span>
              {!props.item.creadorArtculo && <span className="icon-check-2" />}
              {props.item.fechaDePublicacion && (
                <span className="f-card-info-user-date">
                  {getDate(props.item.fechaDePublicacion)}
                </span>
              )}
            </div>

            <span className="f-card-info-category">
              {categoryFilterTitleActive &&
              categoryFilterTitleActive !== "Lo Último"
                ? categoryFilterTitleActive
                : props.item.categorias[0].titulo}
            </span>
            <h3>{props.item.tituloArticulo}</h3>

            <p className="f-card-info-description">
              {props.item.descripcionArticulo}
            </p>
          </div>
        </a>
      )}
    </>
  )
}

export default CardArticleMG
